import { useEffect, useState } from "react"
// The default entry fetches js.stripe.com on import; pure waits for loadStripe.
import { loadStripe } from "@stripe/stripe-js/pure"

export const useStripe = key => {
  const [stripe, setStripe] = useState(null)

  useEffect(() => {
    loadStripe(key).then(setStripe)
  }, [])

  return stripe
}
